import React, { FunctionComponent, useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from '@mui/material';

import { styled } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';
import { IMAGES } from '../../utils/constants';
import { setLogout } from '../../store/slices/auth';
import { useDispatch } from 'react-redux';
import StorageService from '../../services/storageService';
import { useQueryClient } from '@tanstack/react-query';

const CheckboxUI = styled(Checkbox)(({ theme }) => ({
  '&.Mui-checked': {
    color: '#c3183c',
  },
}));

const MultipleExtranet: FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  
  // const checkboxData = [
  //   { id: 1, checked: userInfo?.accessLevel === 'CP' ? true : false, label: 'Channel Partners', disable: true },
  //   { id: 2, checked: userInfo?.accessLevel === 'CUST' ? true : false, label: 'Customers', disable: true },
  //   { id: 3, checked: userInfo?.accessLevel === 'BARKSDALE' ? true : false, label: 'Barksdale Admin', disable: true },
  // ]
  const checkboxData = [
    {
      id: 1,
      checked: true,
      label: 'Channel Partners',
      disable: false,
    },
    {
      id: 2,
      checked: false,
      label: 'Customers',
      disable: true,
    },
    {
      id: 3,
      checked: false,
      label: 'Barksdale Admin',
      disable: false,
    },
  ];

  const [selectedOptions, setSelectedOptions] = useState(checkboxData);

  // Enable Barksdale Admin checkbox only when barksAdmin = true
  useEffect(() => {
    const user = StorageService.getUserInfo();
    if (user && user.accessLevel === 'BARKSDALE') {
      const isBarksAdmin = user.barksAdmin === true;
      setSelectedOptions(prev => 
        prev.map(item => 
          item.id === 3 ? { ...item, disable: !isBarksAdmin } : item
        )
      );
    }
  }, []);

  const toggleCheck = (id: number) => {
    setSelectedOptions((prev) =>
      prev.map((item) => ({
        ...item,
        checked: item.id === id,
      }))
    );
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Get the selected extranet
    const selectedExtranet = selectedOptions.find(option => option.checked);
    
    if (selectedExtranet) {
      // Store the selected extranet in storage for the session
      StorageService.setSelectedExtranet(selectedExtranet.label);
      
      // Navigate to dashboard
      navigate('/dashboard');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#c3183c',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          display: 'flex',
          width: 1000,
          height: 520,
          overflow: 'hidden',
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            width: '50%',
            backgroundImage: `linear-gradient(rgba(255, 0, 64, 0.4), rgba(255, 0, 64, 0.4)), url(${IMAGES.bannerImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />

        <Box
          sx={{
            width: '50%',
            bgcolor: '#f9f9f9',
            px: 6,
            py: 5,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 4 }}
          >
            <Grid>
              <img
                src={IMAGES.barksdaleLogo}
                alt="Barksdale Logo"
                style={{ height: 50 }}
              />
            </Grid>
            <Grid>
              <img
                src={IMAGES.extranetLogo}
                alt="Extranet Logo"
                style={{ height: 50 }}
              />
            </Grid>
          </Grid>

          <Typography variant="h6" gutterBottom>
              You have access to multiple Extranets.
              Please select the Extranet you would like to connect to
          </Typography>

          <Box>
            <FormGroup>
              {selectedOptions.map((item) => (
                <FormControlLabel
                  key={item.id}
                  control={
                    <CheckboxUI
                      name={item.label.toLowerCase()}
                      checked={item.checked}
                      onChange={() => toggleCheck(item.id)}
                      disabled={item.disable}
                    />
                  }
                  label={item.label}
                />
              ))}
            </FormGroup>
          </Box>

          <Box display="flex" gap={2} mt={3}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: '#c3183c',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#a31534',
                },
              }}
              onClick={handleSubmit}
            >
              SUBMIT
            </Button>
            <Button
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: '#c3183c',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#a31534',
                },
              }}
              onClick={() => {
                dispatch(setLogout());
                queryClient.clear();
                sessionStorage.clear();
                localStorage.clear();
                navigate('/login');
              }}
            >
              CANCEL
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default MultipleExtranet;
